import { useState } from 'react';
import { List, ListHeader, ListPageLayout, SearchInput } from 'framework/list';
import { CreateButton } from 'framework/ui/ui-builder';
import { useArtifactStorageService, UPLOAD_ARTIFACT_STORAGE_FILES } from 'domain/shared/artifactStorage';
import ArtifactStorageListLayout from './ArtifactStorageListLayout';
import { useArtifactStorageUrl } from 'domain/shared/artifactStorage';

const ArtifactStorageList = () => {
  const { getListData } = useArtifactStorageService();
  const { getCreateUrl } = useArtifactStorageUrl();
  const [canReloadData, setCanReloadData] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const getData = async (params: any) => {
    const response = await getListData(params);

    setCanReloadData(true);
    setBreadcrumbs(response.path);

    return response;
  };

  return (
    <List getDataMethod={getData}>
      <ListPageLayout
        header={<ListHeader label="Artifacts Storage" icon="fa-file" />}
        actions={[
          <CreateButton
            url={getCreateUrl()}
            label="Add file to storage"
            key="create-artifact-storage"
            permissionToCheck={UPLOAD_ARTIFACT_STORAGE_FILES}
          />,
        ]}
        search={<SearchInput label="name" cleanUpValueWhenChangedFilters />}
      >
        <ArtifactStorageListLayout canReloadData={canReloadData} breadcrumbs={breadcrumbs} />
      </ListPageLayout>
    </List>
  );
};

export default ArtifactStorageList;
